import React from 'react';
import client from '../../../../lib/client';
import {
  RemoveMemberFromGroupMutation,
  RemoveMemberFromGroupMutationVariables
} from '../../../../queries/__generated__/RemoveMemberFromGroupMutation';
import { groupMembersQuery, removeMemberFromGroupMutation } from '../../../../queries/groups';
import { Icon } from '../../../ui';

interface RemoveMemberButton {
  member: {
    id: string;
  };
  group: {
    id: string;
  };
}

const RemoveMemberButton: React.FC<RemoveMemberButton> = ({ member, group }) => {
  function removeMemberFromGroup() {
    client.mutate<RemoveMemberFromGroupMutation, RemoveMemberFromGroupMutationVariables>({
      mutation: removeMemberFromGroupMutation,
      variables: { input: { groupId: group.id, memberId: member.id } },
      refetchQueries: [{ query: groupMembersQuery, variables: { input: { groupId: group.id } } }]
    });
  }

  return (
    <button onClick={removeMemberFromGroup} data-testid="remove-member-button">
      <Icon name="close" size={18} />
    </button>
  );
};

export default RemoveMemberButton;
